import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { DocumentInteraction } from '@app/modules/service-data/types/service-data.types';
import {
  DataTableConfiguration,
  DataTableDataType,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { DataTableComponent } from '../data-table/data-table.component';

@Component({
  selector: 'app-document-interactions-list',
  templateUrl: './document-interactions-list.component.html',
  styleUrls: ['./document-interactions-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DataTableComponent],
})
export class DocumentInteractionsListComponent implements OnInit {
  documentInteractions$ = new BehaviorSubject([]);

  dataTableConfiguration: DataTableConfiguration;

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('rows')
  set _rows(rows: DocumentInteraction[]) {
    this.documentInteractions$.next(
      rows
        .map((interaction) => ({
          ...interaction,
          interacted: moment(interaction.interacted),
        }))
        .sort((a, b) => a.interacted.valueOf() - b.interacted.valueOf())
    );
  }

  ngOnInit(): void {
    this.dataTableConfiguration = {
      title: '',
      selectionMode: DataTableSelectionType.NONE,
      tableHeadClasses: '',
      tableClasses: '',
      tableCellClasses: 'pt-1 pb-0 border-0',
      columns: [
        {
          label: 'shared.documentInteractions.columns.interaction',
          property: 'interaction',
          customStyle: 'width: 17%',
        },
        {
          label: 'shared.documentInteractions.columns.interactedBy',
          property: 'interactedBy',
        },
        {
          label: 'shared.documentInteractions.columns.interacted',
          property: 'interacted',
          customStyle: 'width: 30%',
          type: DataTableDataType.DATETIME,
        },
      ],
      rows$: this.documentInteractions$,
    };
  }
}
